/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsBulkOperationsDeleteAllFromSectionDesktopModel,
  IChatsBulkOperationsDeleteAllFromSectionDesktopRequest,
  IMappers,
  IChatsBulkOperationsDeleteAllFromSectionDesktopResponse,
  IChatsBulkOperationsDeleteAllFromSectionDesktopResponseError,
  TChatsBulkOperationsDeleteAllFromSectionDesktopResponse,
} from './types';

const defaultConfig: TChatsBulkOperationsDeleteAllFromSectionDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/bulk-operations/delete-all-from-section-desktop/',
  hostType: 'api',
} as TChatsBulkOperationsDeleteAllFromSectionDesktopModel;

function createChatsBulkOperationsDeleteAllFromSectionDesktopModel(
  parameters: IChatsBulkOperationsDeleteAllFromSectionDesktopRequest,
): TChatsBulkOperationsDeleteAllFromSectionDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsBulkOperationsDeleteAllFromSectionDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IChatsBulkOperationsDeleteAllFromSectionDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchChatsBulkOperationsDeleteAllFromSectionDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsBulkOperationsDeleteAllFromSectionDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TChatsBulkOperationsDeleteAllFromSectionDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createChatsBulkOperationsDeleteAllFromSectionDesktopModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsBulkOperationsDeleteAllFromSectionDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsBulkOperationsDeleteAllFromSectionDesktopResponseError);
    }
  }

  return { response, statusCode } as TChatsBulkOperationsDeleteAllFromSectionDesktopResponse;
}

export {
  defaultConfig,
  createChatsBulkOperationsDeleteAllFromSectionDesktopModel,
  fetchChatsBulkOperationsDeleteAllFromSectionDesktop,
};
